<template>
  <div
    class="warp-berita-terbaru relative bg-neutral-50 mt-[2vw] px-4 md:px-[15vw]"
  >
    <!-- Layer 1: Background/Wadah -->
    <div class="absolute inset-0 z-0 bg-neutral-50"></div>
    <!-- Layer 2: Ring Image -->
    <div class="ring-right right-0 absolute top-0 z-10 pointer-events-none">
      <img
        src="@/assets/right-ring.png"
        class="h-24 md:h-full"
        alt="right ring"
      />
    </div>
    <div class="ring-left left-0 absolute bottom-0 z-10 pointer-events-none">
      <img
        src="@/assets/left-ring.png"
        class="h-24 md:h-full"
        alt="left ring"
      />
    </div>
    <!-- Layer 3: Main Content -->
    <div class="container mx-auto py-4 text-left relative z-20">
      <div class="title-berita flex justify-between">
        <TitleSection title="Berita Terbaru" />
        <div class="berita-page flex items-center space-x-2 cursor-pointer">
          <div
            class="w-9 outline outline-1 outline-offset-[-0.50px] outline-amber-400"
          ></div>
          <div
            class="w-20 flex justify-center items-center text-emerald-700 text-xs font-normal leading-normal"
          >
            Lihat Semua
          </div>
          <i class="fas fa-arrow-right"></i>
        </div>
      </div>

      <div class="content-berita mt-5">
        <div class="new-berita grid grid-cols-3 gap-4">
          <!-- Very New Berita -->
          <div
            v-if="veryNewBerita"
            class="very-new-berita w-full col-span-3 h-28 md:h-96 bg-white rounded-[5px] shadow-[0px_1px_4px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-neutral-200 overflow-hidden flex cursor-pointer transition-transform"
            @click="navigateToDetail(veryNewBerita)"
          >
            <!-- Gambar -->
            <div class="w-1/2 h-full">
              <img
                :src="veryNewBerita.gambar"
                alt=""
                class="w-full h-full object-cover rounded-l-[5px]"
                style="display: block"
              />
            </div>
            <!-- Konten -->
            <div class="w-1/2 h-full p-4">
              <div
                class="kategori-info text-emerald-700 text-sm font-extralight leading-normal"
              >
                {{ veryNewBerita.kategori }}
              </div>
              <div
                class="judul-info text-emerald-700 text-l md:text-xl font-medium leading-none line-clamp-2 md:line-clamp-1 mt-3"
              >
                {{ veryNewBerita.judul }}
              </div>
              <div
                class="waktu-info text-neutral-400 text-xs md:text-s mt-2 mb-4 font-normal leading-normal"
              >
                {{ veryNewBerita.tanggal }}
              </div>
              <div
                class="deskripsi-info text-l hidden md:block md:line-clamp-6 text-stone-950 overflow-hidden"
              >
                {{ veryNewBerita.isi }}
              </div>
            </div>
          </div>

          <!-- Next Three Berita -->
          <div
            v-for="(berita, index) in nextThreeBerita"
            :key="index"
            class="w-full hidden md:block col-1 h-80 bg-white rounded-[5px] shadow-[0px_1px_4px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-neutral-200 cursor-pointer transition-transform"
            @click="navigateToDetail(berita)"
          >
            <img
              :src="berita.gambar"
              alt=""
              class="w-full h-4/6 object-cover rounded-t-[5px]"
              style="display: block"
            />
            <div class="w-full h-2/6 p-4">
              <div
                class="kategori-info text-emerald-700 text-sm font-extralight leading-normal"
              >
                {{ berita.kategori }}
              </div>
              <div
                class="judul-info text-emerald-700 text-xl font-medium leading-none line-clamp-1 mt-3"
              >
                {{ berita.judul }}
              </div>
              <div
                class="waktu-info text-neutral-400 text-s mt-2 mb-4 font-normal leading-normal"
              >
                {{ berita.tanggal }}
              </div>
            </div>
          </div>


          <!-- Infinite Scroll for Mobile -->
          <div
            class="tampilan_mobile block md:hidden overflow-x-auto whitespace-nowrap scrollbar-hide col-span-3"
            ref="scrollContainer"
            @scroll="handleScroll"
          >
            <div class="inline-flex gap-4 w-max">
              <div
                v-for="(berita, index) in infiniteBerita"
                :key="index"
                @click="navigateToDetail(berita)"
                class=" w-80 h-28 bg-white rounded-[5px] shadow-[0px_1px_4px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-neutral-200 overflow-hidden flex-shrink-0 flex"
              >
                <!-- Gambar -->
                <div class="w-1/2 h-full">
                  <img
                    :src="berita.gambar"
                    alt=""
                    class="w-full h-full object-cover rounded-l-[5px]"
                    style="display: block"
                  />
                </div>
                <!-- Konten -->
                <div class="w-1/2 h-full p-4 overflow-hidden">
                  <div
                    class="kategori-info text-emerald-700 text-sm font-extralight leading-normal"
                  >
                    {{ berita.kategori }}
                  </div>
                  <div
                    class="judul-info text-emerald-700 text-l font-medium leading-none line-clamp-1 mt-3"
                  >
                    {{ berita.judul }}
                  </div>
                  <div
                    class="waktu-info text-neutral-400 text-xs mt-2 mb-4 font-normal leading-normal"
                  >
                    {{ berita.tanggal }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="category-berita grid grid-cols-3 gap-4 mt-2 md:mt-[30px]">
          <div
            v-for="(kategori, kategoriIndex) in kategoriBerita"
            :key="kategoriIndex"
            class="warp-per-category col-span-3 md:col-span-1"
          >
            <div
              class="title-category hidden md:block my-1 mb-5 flex justify-center items-center"
            >
              <MiniTitle :title="kategori.berita[0].kategori" />
            </div>

            <div
              class="title-category my-1 block md:hidden flex justify-center items-center"
              @click="toggleMobileScroll(kategoriIndex)"
            >
              <MiniTitle :title="kategori.berita[0].kategori" />
              <span class="md:hidden ml-2">
                <button
                      @click="toggleMobileScroll(kategoriIndex)"
                  class="focus:outline-none"
                  aria-label="Toggle kategori"
                >
                  <i
                    :class="[
                      'fas',
                      mobileScrollVisible[kategoriIndex] ? 'fa-chevron-up' : 'fa-chevron-down',
                      'text-emerald-700',
                      'transition-transform',
                      'duration-200'
                    ]"
                  ></i>
                </button>
              </span>
            </div>

            <!-- Berita Terbaru di Kategori -->
            <div
              v-if="kategori.berita.length > 0"
              @click="navigateToDetail(berita)"
              class=" cursor-pointer w-full hidden md:block h-80 bg-white rounded-[5px] shadow-[0px_1px_4px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-neutral-200"
            >
              <img
                :src="kategori.berita[0].gambar"
                alt=""
                class="w-full h-4/6 object-cover rounded-t-[5px]"
                style="display: block"
              />
              <div class="w-full h-2/6 p-4">
                <div
                  class="kategori-info text-emerald-700 text-sm font-extralight leading-normal"
                >
                  {{ kategori.nama }}
                </div>
                <div
                  class="judul-info text-emerald-700 text-xl font-medium leading-none line-clamp-1 mt-3"
                >
                  {{ kategori.berita[0].judul }}
                </div>
                <div
                  class="waktu-info text-neutral-400 text-s mt-2 mb-4 font-normal leading-normal"
                >
                  {{ kategori.berita[0].tanggal }}
                </div>
              </div>
            </div>

            <!-- Berita Lainnya di Kategori -->
            <div class="child-category mt-2 hidden md:block">
              <div
                v-for="(berita, beritaIndex) in kategori.berita.slice(1, 3)"
                :key="beritaIndex"
                @click="navigateToDetail(berita)"
                class="cursor-pointer w-100 h-28 bg-white rounded-[5px] mb-2 shadow-[0px_1px_4px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-neutral-200 overflow-hidden flex-shrink-0 flex"
              >
                <!-- Gambar -->
                <div class="w-1/2 h-full">
                  <img
                    :src="berita.gambar"
                    alt=""
                    class="w-full h-full object-cover rounded-l-[5px]"
                    style="display: block"
                  />
                </div>
                <!-- Konten -->
                <div class="w-1/2 h-full p-4 overflow-hidden">
                  <div
                    class="judul-info text-emerald-700 text-l font-medium leading-none line-clamp-1 mt-3"
                  >
                    {{ berita.judul }}
                  </div>
                  <div
                    class="waktu-info text-neutral-400 text-xs mt-2 mb-4 font-normal leading-normal"
                  >
                    {{ berita.tanggal }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Infinite Scroll for Mobile per Kategori -->
            <transition name="slide-fade">
              <div
                v-if="mobileScrollVisible[kategoriIndex]"
                class="tampilan_mobile block md:hidden overflow-x-auto whitespace-nowrap scrollbar-hide col-span-3"
                ref="scrollContainer"
                @scroll="handleScroll"
              >
                <div class="inline-flex gap-4 w-max">
                  <div
                    v-for="(berita, beritaIndex) in kategori.berita.slice(0, 3)"
                    :key="beritaIndex"
                    @click="navigateToDetail(berita)"
                    class="w-80 h-28 bg-white rounded-[5px] shadow-[0px_1px_4px_0px_rgba(0,0,0,0.10)] cursor-pointer outline outline-1 outline-neutral-200 overflow-hidden flex-shrink-0 flex"
                  >
                    <div class="w-1/2 h-full">
                      <img
                        :src="berita.gambar"
                        alt=""
                        class="w-full h-full object-cover rounded-l-[5px]"
                        style="display: block"
                      />
                    </div>
                    <div class="w-1/2 h-full p-4 overflow-hidden">
                      <div
                        class="kategori-info text-emerald-700 text-sm font-extralight leading-normal"
                      >
                        {{ kategori.nama }}
                      </div>
                      <div
                        class="judul-info text-emerald-700 text-l font-medium leading-none line-clamp-1 mt-3"
                      >
                        {{ berita.judul }}
                      </div>
                      <div
                        class="waktu-info text-neutral-400 text-xs mt-2 mb-4 font-normal leading-normal"
                      >
                        {{ berita.tanggal }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <div
              v-if="mobileScrollVisible[kategoriIndex]"
              class="flex justify-end md:flex md:justify-end"
            >
              <router-link
                :to="{ name: 'BeritaByCategory', params: { slug_cat: kategori.slug_cat } }"
                class="berita-kategori-page flex items-center space-x-2 cursor-pointer"
              >
                <div class="w-20 flex justify-center items-center text-emerald-700 text-xs font-normal leading-normal">
                  Lihat Semua
                </div>
                <i class="fas fa-arrow-right"></i>
              </router-link>
            </div>

            <div
              class="hidden md:flex justify-end"
            >
              <div
                class="berita-kategori-page flex items-center space-x-2 cursor-pointer"
                @click="navigateToCategory(kategori)"
              >
                <div
                  class="w-20 flex justify-center items-center text-emerald-700 text-xs font-normal leading-normal"
                >
                  Lihat Semua
                </div>
                <i class="fas fa-arrow-right"></i>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, reactive } from "vue";
import { useBeritaStore } from "@/store/beritaStore";
import TitleSection from "@/components/TitleSection.vue";
import MiniTitle from "@/components/MiniTitle.vue";
import { useRouter } from 'vue-router';

/* Removed export default block as it's not allowed in <script setup> */

const store = useBeritaStore();
const scrollContainer = ref(null);
const router = useRouter();

const sortedBerita = computed(() => {
  return [...store.berita].sort(
    (a, b) => new Date(b.created_time) - new Date(a.created_time)
  );
});

const veryNewBerita = computed(() => sortedBerita.value[0]);

const nextThreeBerita = computed(() => sortedBerita.value.slice(1, 4));

const infiniteBerita = computed(() => {
  return [...nextThreeBerita.value, ...nextThreeBerita.value];
});

const kategoriBerita = computed(() => {
  const grouped = {};
  store.berita.forEach((berita) => {
    if (!grouped[berita.slug_cat]) {
      grouped[berita.slug_cat] = [];
    }
    grouped[berita.slug_cat].push(berita);
  });

  return Object.keys(grouped).map((slug_cat) => ({
    slug_cat,
    berita: grouped[slug_cat].sort(
      (a, b) => new Date(b.created_time) - new Date(a.created_time)
    ),
  }));
});

const mobileScrollVisible = reactive({});

const toggleMobileScroll = (index) => {
  mobileScrollVisible[index] = !mobileScrollVisible[index];
};

const handleScroll = () => {
  const container = scrollContainer.value;
  if (!container) return;

  // Check if the user has scrolled to the end of the container
  if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 10) {
    // Append more items to infiniteBerita (simulate infinite scroll)
    store.loadMoreBerita(); // Ensure this method exists in your store
  }
};

const navigateToCategory = (kategori) => {
  const slug_cat = kategori?.slug_cat;
  if (!slug_cat) {
    console.error('Missing required param "slug_cat"');
    return;
  }
  router.push({ name: 'BeritaByCategory', params: { slug_cat: slug_cat.trim() } });
};

const navigateToDetail = (berita) => {
  router.push({
    name: 'DetailBerita',
    params: { slug_cat: berita.slug_cat, slug_berita: berita.slug_berita },
  });
};

onMounted(() => {
  const container = scrollContainer.value;
  container.scrollLeft = 0;
});
</script>

<style scoped lang="scss">
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
